import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, Observable, of, Subscription, tap } from 'rxjs';
import { DATE_TIME_FORMAT } from 'src/app/config/global.config';
import { AppState } from 'src/app/core/app.state';
import { ICatalog } from 'src/app/features/catalogs/models/catalogs.models';
import { ClearCatalog, FetchAllCompanyCatalogsById, GetCatalogById, GetProductsCatalogCompanyById } from 'src/app/features/catalogs/store/catalogs.actions';
import { ICurrency, ILocation } from 'src/app/features/customers/models/customers.models';
import { FetchAllLocations } from 'src/app/features/customers/store/customers.actions';
import { IProduct, IVariant } from 'src/app/features/produits/models/products.models';
import { IAskForQuotationProduct, INewQuotation, IQuotationProduct } from '../../models/quotations.models';
import { DraftNewQuotation, DraftNewQuotationSuccess, SendNewQuotation, SendNewQuotationSuccess } from '../../store/quotations.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { quantityValidator } from 'src/app/shared/validators/fields-validators';
import { MatCheckbox } from '@angular/material/checkbox';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { capitalize } from 'src/app/shared/utils/helpers';
import { CommonService } from 'src/app/shared/common.service';
import { ProductCodeService } from 'src/app/core/services/product-code.service';

@Component({
  selector: 'app-add-quotation',
  templateUrl: './add-quotation.component.html',
  styleUrls: ['./add-quotation.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class AddQuotationComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper | undefined;
  form: FormGroup = new FormGroup({});
  nameControlLocation: FormControl = new FormControl();
  nameControleCatalog: FormControl = new FormControl();
  nameControleProduct: FormControl = new FormControl();
  DATE_FORMAT = DATE_TIME_FORMAT;

  placeholder: string = 'assets/images/placeholder.png';
  currentLocatonName: string = '';
  currentLocatonId: number = 0;
  currentCatalogId: number = 0;
  currentLocationCurrency!: ICurrency;
  currentCatalogCurrencies: ICurrency[] = [];
  currencyControl: FormControl = new FormControl();
  locations$: Observable<ILocation[]> = of([]);
  catalogs$: Observable<ICatalog[]> = of([]);
  products$: Observable<IProduct[]> = of([]);
  products: IQuotationProduct[] = [];
  isMarginOnCost: boolean = false;

  currentFilter: IQuotationProduct[] = []
  productsForm!: FormGroup;
  @ViewChild('checkBox') checkBox!: MatCheckbox;
  isFinalQuote: boolean = false;
  private subscriptions: Subscription[] = [];
  baseUrl = environment.BASE_URL_API;
  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private commonService: CommonService,
    public productCode: ProductCodeService
  ) {
    this.form = this.fb.group({
      startDateTime: [''],
      endDateTime: [''],
      minTotalPrice: [''],
      maxTotalPrice: [''],
      minTotalSales: [''],
      maxTotalSales: [''],
      minNbrOfSKU: [''],
      maxNbrOfSKU: [''],
      minDiscount: [''],
      maxDiscount: [''],
      minStock: [''],
      maxStock: [''],
      minPrice: [''],
      maxPrice: [''],
      brands: [''],
      categories: [''],
      isMultiBrands:[false],
      isMonoBrands:[false],
    });
    this.productsForm = this.fb.group({
    });
  }
  brands: { id: number | null; name: string }[] = [];
  categories: { id: number; name: string }[] = [];
  startDateTime: Date | null = null;
  endDateTime: Date | null = null;
  filteredLocations: ILocation[] = [];
  currentFilterApplied: any = {};
  ngOnInit(): void {
    this.store.dispatch(FetchAllLocations());
    this.locations$ = this.store.select((state) => state.customers.allLocations);
    this.catalogs$ = this.store.select((state) => state.catalogs.locationCatalogs);
    this.products$ = this.store.select((state) => state.catalogs.products);
    const sub1 = this.products$.subscribe(products => {
      this.products = products.map((p: IProduct) => {
        if (!this.brands.find((brand) => brand.id === p.brand?.id)) {
          if(p.brand?.id === null)
          {
            this.brands.push({id: null, name: this.translateService.instant('quotations_and_orders.without_brand')})
          }
          else if(p.brand){
            this.brands.push({ id: p.brand.id, name: capitalize(p.brand.name) });
          }
        }
        const categories = [...this.categories, ...(p.categories || [])];

        const productCategories = Array.from(
          new Map(categories.map(category => [category.id, category])).values()
        );
        this.categories = productCategories;
        
        // Get currency-specific prices
        const selectedCurrencyId = this.currencyControl.value;
        const productPrices = selectedCurrencyId ? this.getPricesFromCurrency(p, selectedCurrencyId) : { sales_price: p.sales_price ?? null, final_price: p.final_price ?? 0 };
        return {
          product_id: p.id!,
          name: p.name,
          discount: p.discount ?? 0,
          initial_discount: p.discount ?? 0,
          cost: p.cost,
          image: p.image,
          quantity: p.min_qte ?? p.increment ?? 0,
          sku: p.sku,
          erp_id: p.erp_id,
          stock: p.stock,
          price_unit: productPrices.sales_price,
          increment: p.increment,
          max_qte: p.max_qte,
          min_qte: p.min_qte,
          checked: false,
          brand_id: p.brand?.id as number,
          categories: p.categories || [],
          final_price: productPrices.final_price ? productPrices.final_price : (productPrices.sales_price!) - ((productPrices.sales_price!) * (p.discount ?? 0) / 100),
          killing_stock_limit: p.killing_stock_limit ?? 0,
          total_open_quantity: p.total_open_quantity ?? 0,
          is_owned: p.is_owned,
          status: p.status,
          stock_by_warehouse: p.stock_by_warehouse,
          reserved_stock: p.reserved_stock || [],
        };
      });
      this.brands.sort((first, second) => (first.name < second.name ? -1 : 1));
      this.categories.sort((first, second) => (first.name < second.name ? -1 : 1));

      const controls = Object.keys(this.productsForm.controls);
      controls.forEach(controlName => {
        this.productsForm.removeControl(controlName);
      });

      this.products.forEach((product: IQuotationProduct) => {
        this.productsForm.addControl(`quantity_${product.product_id}`, new FormControl({ value: product.quantity, disabled: !product.checked }, [Validators.required, quantityValidator(product,this.translateService)]));
        this.productsForm.addControl(`final_price_${product.product_id}`, new FormControl({ value: product.final_price, disabled: !product.checked }, [Validators.required]));
      })

      this.applyFilter();
      this.applyDateRangeFilter();
    });
    const sub2 = this.nameControleProduct.valueChanges.subscribe(() => this.applyFilter());
    const sub3 = this.currencyControl.valueChanges.subscribe(() => this.updateProductPricesForCurrency());
    const sub4 = this.actions$.pipe(
      ofType(DraftNewQuotationSuccess, SendNewQuotationSuccess),
      tap((action) => {
        this.router.navigate(['quotations/', action.quotation.id]);
      })).subscribe();

    this.subscriptions.push(sub1, sub2, sub3, sub4);
  }

FiltredLocations(locations: ILocation[]): ILocation[] {
  return locations.filter((location: ILocation) => {
    const nameMatches = location.name?.toLowerCase().includes(this.nameControlLocation.value?.toLowerCase() ?? '') || location.company_name?.toLowerCase().includes(this.nameControlLocation.value?.toLowerCase() ?? '');
    const locationLastOrder = location.last_order ? new Date(location.last_order) : null;
    const startDateTimeMatches = !this.currentFilterApplied?.startDateTime || !locationLastOrder || locationLastOrder >= new Date(this.currentFilterApplied.startDateTime);
    const endDateTimeMatches = !this.currentFilterApplied?.endDateTime || !locationLastOrder || locationLastOrder <= new Date(this.currentFilterApplied.endDateTime);
    const minTotalPriceMatches = !this.currentFilterApplied?.minTotalPrice || (location.total_orders_amount ?? 0) >= +this.currentFilterApplied.minTotalPrice;
    const maxTotalPriceMatches = !this.currentFilterApplied?.maxTotalPrice || (location.total_orders_amount ?? 0) <= +this.currentFilterApplied.maxTotalPrice;
    const minTotalSalesMatches = !this.currentFilterApplied?.minTotalSales || (location.total_orders_count ?? 0) >= +this.currentFilterApplied.minTotalSales;
    const maxTotalSalesMatches = !this.currentFilterApplied?.maxTotalSales || (location.total_orders_count ?? 0) <= +this.currentFilterApplied.maxTotalSales;

    return nameMatches && minTotalPriceMatches && maxTotalPriceMatches && minTotalSalesMatches && maxTotalSalesMatches && startDateTimeMatches && endDateTimeMatches;
  });
}

filtredCatalogs(catalogs: ICatalog[]): ICatalog[] {
  return catalogs.filter((catalog: ICatalog) => {
    const nameMatches = catalog.name?.toLowerCase().includes(this.nameControleCatalog.value?.toLowerCase() ?? '');
    const maxDiscountMatches = !this.currentFilterApplied?.maxDiscount || (catalog.general_discount ?? 0) <= +this.currentFilterApplied.maxDiscount;
    const minDiscountMatches = !this.currentFilterApplied?.minDiscount || (catalog.general_discount ?? 0) >= +this.currentFilterApplied.minDiscount;
    const maxNbrOfSKUMatches = !this.currentFilterApplied?.maxNbrOfSKU || (catalog.nbr_products ?? 0) <= +this.currentFilterApplied.maxNbrOfSKU;
    const minNbrOfSKUMatches = !this.currentFilterApplied?.minNbrOfSKU || (catalog.nbr_products ?? 0) >= +this.currentFilterApplied.minNbrOfSKU;
    let brandFilter = true
    if(this.currentFilterApplied?.isMonoBrands && !this.currentFilterApplied?.isMultiBrands) {
      brandFilter = catalog.nbr_brands === 1
    } else if(this.currentFilterApplied?.isMultiBrands && !this.currentFilterApplied?.isMonoBrands) {
      brandFilter = catalog.nbr_brands! > 1
    }

    return nameMatches && maxDiscountMatches && minDiscountMatches && maxNbrOfSKUMatches && minNbrOfSKUMatches && brandFilter;
  });
}

disableCatalog(catalog: ICatalog): boolean {
  if(catalog.nbr_products === 0 || catalog.status === 'Draft') return true;
  if(catalog.end_date) {
    const endDate = new Date(catalog.end_date!);
    endDate.setHours(23, 59, 59, 999);
    if(endDate < new Date()) return true;
  }
  return false;
}

  updateQuantity(event: Event, product: IQuotationProduct) {
    const quantity = +(event.target as HTMLInputElement).value;
    product.quantity = quantity;
  }

  getFinalPrice(product: IQuotationProduct): number {
    return product.price_unit
    ? (
        product.discount
        ? product.price_unit * (1 - (product.discount / 100))
        : product.price_unit
      ) : 0;
  }

  updateDiscount(event: any, product: IQuotationProduct) {
    let discount = event.target.value
    if (discount.endsWith(',') || discount.endsWith('.')) return;
    const [_, dec] = discount.split(/[,.]/)
    if (dec && dec.length > 2) {
      discount = Number((+discount).toFixed(2))
      event.target.value = discount
    }
    discount = Number(discount)
    if (discount < 0 || discount > 100) {
      discount = Math.min(Math.max(discount, 0), 100);
      event.target.value = discount
    }

    product.discount = discount;

    const newFinalPrice = this.getFinalPrice(product);
    product.final_price = newFinalPrice;

    if(newFinalPrice) {
      const controlName = 'final_price_' + product.product_id;
      const control = this.productsForm.get(controlName);
      control?.setValue(newFinalPrice, { emitEvent: false });
    }
  }

  updateFinalPrice(event: any, product: IQuotationProduct) {
    let finalPrice = event.target.value, key = event.data;
    if ([',', '.'].includes(key)) {
      return;
    }

    finalPrice = Number(finalPrice);

    if (finalPrice > product.price_unit!) {
      event.target.value = product.price_unit;
      product.final_price = product.price_unit!;
      product.discount = 0;
      return;
    }

    // Check if the number is positive
    if (finalPrice <= 0) {
      event.target.value = 0;
      product.final_price = 0;
      product.discount = 100;
      return;
    }

    product.final_price = finalPrice;
    product.discount = product.price_unit ? Number(100 - (finalPrice * 100 / product.price_unit)) : 0;
}

  checkAllProducts(event: any | boolean) {
    const checked = event.checked;
    if (checked) {
      this.currentFilter.forEach((product: IQuotationProduct) => {
        if ((((product.stock && product.stock.quantity >= product.min_qte!) && product.is_owned) || !product.is_owned) && product.status !== 'Draft') {
          this.productsForm.get(`quantity_${product.product_id}`)?.enable();
          this.productsForm.get(`final_price_${product.product_id}`)?.enable();
          product.checked = checked;
        }
      });
    } else {
      this.products.forEach((product: IQuotationProduct) => {
        product.quantity = product.min_qte!;
        this.productsForm.get(`quantity_${product.product_id}`)?.setValue(product.min_qte);
        this.productsForm.get(`quantity_${product.product_id}`)?.disable();
        this.productsForm.get(`final_price_${product.product_id}`)?.disable();
        product.checked = checked;
      })
    }
  }

  isAllChecked() {
    return (
      this.currentFilter.length > 0 &&
      this.currentFilter.every(
        (product) =>
          product.checked ||
          (product.status === 'Draft' || ((!product.stock || product.stock && product.stock.quantity < product.min_qte!) && product.is_owned))
      )
    );
  }

  isKillingStock(product: IQuotationProduct): boolean {
    if(product.checked && product.killing_stock_limit) {
      const is_killing_stock: boolean = product.quantity + product.killing_stock_limit > 0;
      return is_killing_stock;
    }
    else return false;
  }

  killingStockMessage(product: IQuotationProduct){
      if(product.is_owned && this.isKillingStock(product))
      {
        const qte = parseInt(this.productsForm.get(`quantity_${product.product_id}`)?.value);
        if(product.total_open_quantity && product.stock && (product.total_open_quantity + qte) > product.stock.quantity)
        {
          return "insufficient_stock_combined_orders"
        }
        else {
          return "requested_quantity_exceeds_available_stock"
        }
      }
      return false;
    }

  exceededStock(product: IQuotationProduct): number {
    if(product.checked && product.killing_stock_limit ) {
      return product.quantity + product.killing_stock_limit;
    }
    else return 0;
  }

  isStockAlert(product: IQuotationProduct): boolean {
    if (this.isMarginOnCost && (!product.cost || product.cost === 0)) {
      return true;
    }
    if(product.is_owned)
    {
      if((product.killing_stock_limit ?? 0) - product.quantity < 0 || product.quantity >= (product.stock?.quantity ?? 0)) return true;
    }
    return false;
  }

  alertType(product: IQuotationProduct): string {
    if (this.isMarginOnCost && (!product.cost || product.cost === 0)) {
      return 'alert_div_warning';
    }
    if(product.quantity > (product.stock?.quantity ?? 0)) return 'alert_div_danger';
    if((product.killing_stock_limit ?? 0) - product.quantity < 0 || product.quantity == product.stock?.quantity) return 'alert_div_warning';
    return '';
  }

  alertMessage(product: IQuotationProduct): string {
    if (this.isMarginOnCost && (!product.cost || product.cost === 0)) {
      return 'quotations_and_orders.cost_missing_single';
    }
    if(product.quantity > (product.stock?.quantity ?? 0)) return 'quotations_and_orders.requested_quantity_exceeds_available_stock';
    if((product.killing_stock_limit ?? 0) - product.quantity < 0) return 'quotations_and_orders.insufficient_stock_combined_orders';
    if(product.quantity == (product.stock?.quantity ?? 0)) return 'quotations_and_orders.order_deplete_available_stock';
    return '';
  }

  allProductsDisable(): boolean {
    return this.currentFilter.length === 0 || this.currentFilter.every((product: IQuotationProduct) => ((product.status === 'Draft') || ((!product.stock || product.stock && product.stock.quantity < product.min_qte!) && product.is_owned)));
  }

  shouldDisableProductLine(product: IQuotationProduct): boolean {
    if (product.status === 'Draft') return true;
    if (!product.stock || (product.stock && product.stock.quantity < product.min_qte!)) {
      return product.is_owned === true && product.can_be_sold_out_of_stock === false;
    }
    return false;
  }

  productsSelected(): number {
    return this.products.filter((product: IQuotationProduct) => product.checked).length;
  }
  totalQuantity(): number {
    return this.products.filter((product: IQuotationProduct) => product.checked).reduce((acc, product) => {
      return acc + product.quantity;
    }, 0);
  }

  totalPrice(): number {
    return this.products.filter((product: IQuotationProduct) => product.checked).reduce((acc, product) => {
      return acc + (product.final_price ? product.quantity * product.final_price : (product.quantity * (product.price_unit! * (1 - product.discount / 100)))) ;
    }, 0);
  }

  checkProduct(product: IQuotationProduct, event: any) {
    const checked = event.checked;
    if (checked) {
      this.productsForm.get(`quantity_${product.product_id}`)?.enable();
      this.productsForm.get(`final_price_${product.product_id}`)?.enable();
    } else {
      product.quantity = product.min_qte!;
      this.productsForm.get(`quantity_${product.product_id}`)?.setValue(product.min_qte);
      this.productsForm.get(`quantity_${product.product_id}`)?.disable();
      this.productsForm.get(`final_price_${product.product_id}`)?.disable();
    }
  }

  clearFilters() {
    this.form.reset({
      startDateTime: '',
      endDateTime: '',
      minTotalPrice: '',
      maxTotalPrice: '',
      minTotalSales: '',
      maxTotalSales: '',
      minNbrOfSKU: '',
      maxNbrOfSKU: '',
      minDiscount: '',
      maxDiscount: '',
      minStock: '',
      maxStock: '',
      minPrice: '',
      maxPrice: '',
      brands: '',
      categories: ''
    });
    this.applyFilter();
  }

  applyFilter() {
    this.currentFilterApplied = this.form.value;

    this.currentFilter = this.products.filter(product => {
      const nameOrSkuMatches = !this.nameControleProduct.value ||
        product.name?.toLowerCase().includes(this.nameControleProduct.value?.toLowerCase()) ||
        product.sku?.toLowerCase().includes(this.nameControleProduct.value?.toLowerCase());

      const stockMatches = (!this.currentFilterApplied?.minStock || product.stock?.quantity! >= +this.currentFilterApplied.minStock) &&
        (!this.currentFilterApplied?.maxStock || product.stock?.quantity! <= +this.currentFilterApplied.maxStock);

      const priceMatches = (!this.currentFilterApplied?.minPrice || product.price_unit! >= +this.currentFilterApplied.minPrice) &&
        (!this.currentFilterApplied?.maxPrice || product.price_unit! <= +this.currentFilterApplied.maxPrice);

      const brandMatches = !this.currentFilterApplied?.brands || product.brand_id === +this.currentFilterApplied.brands || (product.brand_id === null && this.currentFilterApplied.brands === 'null');
      const categoryMatches = !this.currentFilterApplied?.categories || product.categories?.map(category => category.id).includes(+this.currentFilterApplied.categories);

      return nameOrSkuMatches && stockMatches && priceMatches && brandMatches && categoryMatches;
    });
  }

  applyDateRangeFilter() {
    this.filterByDateRange(this.startDateTime, this.endDateTime).subscribe(filteredLocations => {
      this.filteredLocations = filteredLocations;
    });
  }

  filterByDateRange(startDateTime: Date | null, endDateTime: Date | null): Observable<ILocation[]> {
    return this.locations$.pipe(
      map(locations => {
        return locations.filter(location => {
          const lastOrderDate = location.last_order ? new Date(location.last_order) : null;
          return !startDateTime || !endDateTime || (lastOrderDate && lastOrderDate >= startDateTime && lastOrderDate <= endDateTime);
        });
      })
    );
  }
  isCurrentStep(stepIndex: number): boolean {
    return this.stepper ? this.stepper.selectedIndex === stepIndex : false;
  }

  getCatalogs(location: ILocation): boolean | void {
    if(location.nbr_catalogs === 0){
      return false;
    }
    this.currentLocationCurrency = location.currency!;
    this.nameControlLocation.setValue('');
    this.currentLocatonName = location.name;
    this.currentLocatonId = location.id!;
    this.stepper!.next();
    this.store.dispatch(FetchAllCompanyCatalogsById({ id: location.id! }));
  }

  getProducts(catalog: ICatalog): boolean | void {
    if(catalog.nbr_products === 0){
      return false;
    }
    this.store.dispatch(ClearCatalog());
    if (catalog.id) {
      this.store.dispatch(GetCatalogById({ id: catalog.id }));
    }
    
    this.isMarginOnCost = catalog.overall_pricing_rule === 'margin_on_cost';
    this.currentCatalogCurrencies = catalog.currencies!;
    // if currnentLocationCurrency is in currentCatalogCurrencies, set the currencyControl value to the currentLocationCurrency if not set it to the currency has is_default true
    if(this.currentCatalogCurrencies.some(currency => currency.id === this.currentLocationCurrency.id)){
      this.currencyControl.setValue(this.currentLocationCurrency.id);
    } else {
      this.currencyControl.setValue(this.currentCatalogCurrencies.find(currency => currency.is_main)?.id);
    }
    
    this.currentCatalogId = catalog.id!;
    this.stepper!.next();
    this.store.dispatch(GetProductsCatalogCompanyById({ locationId: this.currentLocatonId, catalogId: catalog.id! }));
  }

  SendQuotation(stype: string): void | boolean {
    if(this.products.filter(product => product.checked).length === 0){
      this.commonService.showToast(
        this.translateService.instant('Catalogs.selectedAtLeastProduct'),
        'WARNING'
      );
      return false
    }

    if (this.productsForm.invalid) {
      this.productsForm.markAllAsTouched();
      return false;
    }

    const products: IAskForQuotationProduct[] = this.products.filter(product => product.checked).map((product: IQuotationProduct) => {
      const mainWarehouse = product.stock_by_warehouse?.find((stock: any) => stock.is_primary && stock.stock_id !== null);
      const stock_reservation = mainWarehouse ? [{
        id: 0,
        state: 'draft',
        warehouse_id: mainWarehouse.warehouse_id || 0,
        order_id: 0,
        stock_id: mainWarehouse.stock_id || 0,
        quantity: product.quantity,
      }] : [];
      return {
        product_id: product.product_id,
        name: product.name,
        quantity: product.quantity,
        discount: product.discount,
        increment: product.increment,
        min_qte: product.min_qte,
        max_qte: product.max_qte,
        sku: product.sku,
        price_unit: product.price_unit,
        total_discount: product.discount,
        final_price: product.final_price,
        stock_reservation: stock_reservation
      }
    });

    const payload: INewQuotation = {
      partner_id: this.currentLocatonId,
      pricelist_id: this.currentCatalogId,
      is_final: this.isFinalQuote,
      products,
      currency_id: this.currencyControl.value
    }

    if (stype === 'Draft') {
      this.store.dispatch(DraftNewQuotation({ newQuotation: payload }));
    } else {
      this.store.dispatch(SendNewQuotation({ newQuotation: payload }));
    }
  }

  cancel() {
    if (this.stepper?.selectedIndex === 0) {
      this.router.navigate(['/quotations'], {
        relativeTo: this.activatedRoute,
        queryParamsHandling: 'merge',
      })
    }
    this.stepper?.previous();
    this.nameControlLocation.setValue('');
    this.nameControleCatalog.setValue('');
    this.nameControleProduct.setValue('');
    this.clearFilters();
    this.checkBox.checked = false;
  }

  /**
   * Get prices from product currencies based on selected currency ID
   */
  private getPricesFromCurrency(product: IProduct, currencyId: number): { sales_price: number | null; final_price: number } {
    console.log(product.currencies);
    if (product.currencies && product.currencies.length > 0) {
      const currencyData = product.currencies.find(currency => currency.currency_id === currencyId);
      if (currencyData) {
        return {
          sales_price: currencyData.sales_price ?? null,
          final_price: currencyData.final_price ?? product.final_price ?? 0
        };
      }
    }
    // Fallback to default prices if currency not found
    return {
      sales_price: product.sales_price ?? 0,
      final_price: product.final_price ?? 0
    };
  }

  /**
   * Update product prices when currency changes
   */
  private updateProductPricesForCurrency(): void {
    const selectedCurrencyId = this.currencyControl.value;
    if (!selectedCurrencyId || this.products.length === 0) return;

    // Get the current products from the store to access currency data
    this.products$.pipe(
      map(products => {
        this.products.forEach((quotationProduct: IQuotationProduct) => {
          // Find the original product data
          const originalProduct = products.find(p => 
            p.id === quotationProduct.product_id
          );

          if (originalProduct) {
            let newPriceUnit = quotationProduct.price_unit;
            let newFinalPrice = quotationProduct.final_price;
            const productPrices = this.getPricesFromCurrency(originalProduct, selectedCurrencyId);
            newPriceUnit = productPrices.sales_price;
            newFinalPrice = productPrices.final_price ? productPrices.final_price :
              (productPrices.sales_price!) - ((productPrices.sales_price!) * (originalProduct.discount ?? 0) / 100);

            // Update the quotation product
            quotationProduct.price_unit = newPriceUnit;
            quotationProduct.final_price = newFinalPrice;
            quotationProduct.discount = quotationProduct.initial_discount ?? 0;
            // Update form controls
            const finalPriceControl = this.productsForm.get(`final_price_${quotationProduct.product_id}`);
            if (finalPriceControl) {
              finalPriceControl.setValue(newFinalPrice, { emitEvent: false });
            }
          }
        });
      })
    ).subscribe();
    
    this.checkAllProducts(true);
    this.productsForm.updateValueAndValidity();
    this.applyFilter();
  }

  getCurrencySymbol(): string {
    return this.currencyControl.value ? this.currentCatalogCurrencies.find(currency => currency.id === this.currencyControl.value)?.symbol || '' : '';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub => sub.unsubscribe()))
  }
}
